import React from 'react';
import { useScannerSearchModule } from '../../Modules';
import {
  ScannerSearchItemData,
  ScannerSearchItem,
  createScannerSearchItem,
  isScannerSearchItem,
  SearchItem,
} from '@benzinga/search-modules';
import { TokenData } from '../tokenize';
import { ExpressionModule, ExpressionSearchModule } from './ExpressionModules';

export interface ScannerExpressionData {
  leftOperand: 'Tickers.name';
  operator: 'object';
  rightOperand: { scanner_id: string };
}

export interface ScannerExpressionModule extends ExpressionModule<ScannerSearchItemData> {
  toTokenData: (item: SearchItem) => ScannerExpressionData | undefined;
  fromTokenData: (token: TokenData<unknown>) => ScannerSearchItem | undefined;
}

export const isScannerExpressionData = (token: TokenData<unknown>): token is ScannerExpressionData => {
  return (
    token.leftOperand === 'Tickers.name' &&
    token.operator === 'object' &&
    typeof token.rightOperand === 'object' &&
    token.rightOperand != null &&
    'scanner_id' in token.rightOperand
  );
};

export const createScannerExpressionModule = (): ScannerExpressionModule => {
  return {
    fromTokenData: token => {
      if (!isScannerExpressionData(token)) return undefined;
      return createScannerSearchItem(token.rightOperand.scanner_id);
    },
    toTokenData: item => {
      if (!isScannerSearchItem(item)) return undefined;
      return {
        leftOperand: 'Tickers.name',
        operator: 'object',
        rightOperand: { scanner_id: item.data.scannerId },
      };
    },
  };
};

export const useScannerExpressionSearchModule = (): ExpressionSearchModule => {
  const linkingModule = useScannerSearchModule();
  return React.useMemo(() => ({ ...linkingModule, expression: createScannerExpressionModule() }), [linkingModule]);
};
